/** @deprecated */
export enum Endpoint {
    // COM TOKEN

    ImportacaoNFERecebida = 'Importacao/NFERecebida',
    ImportacaoNFEEmitida = 'Importacao/NFEEmitida',

    FinanceiroMovimentoAnexo = 'FinanceiroMovimentoAnexo/Anexo',
    FinanceiroMovimentoLancamento = 'FinanceiroMovimentoLancamento/Lancamento',
    FinanceiroMovimentoLancamentoEstornar = 'FinanceiroMovimentoLancamento/Estornar',
    FinanceiroMovimentoContaReceber = 'FinanceiroMovimento/ContaReceber',
    FinanceiroMovimentoCompartilhar = 'FinanceiroMovimento/Compartilhar',
    FinanceiroMovimentoEstornar = 'FinanceiroMovimento/Estornar',
    FinanceiroMovimentoContaPagar = 'FinanceiroMovimento/ContaPagar',
    FinanceiroMovimentoValoresTotais = 'FinanceiroMovimento/ValoresTotais',
    FinanceiroMovimentoBoleto = 'FinanceiroMovimento/Boleto',
    FinanceiroMovimentoBoletoValoresTotais = 'FinanceiroMovimento/BoletoValoresTotais',
    FinanceiroMovimentoBoletoGerarListaPDFs = 'FinanceiroMovimento/BoletoGerarPDF',
    FinanceiroMovimentoPixCobranca = 'FinanceiroMovimento/PixCobranca',
    FinanceiroMovimentoPix = 'FinanceiroMovimento/Pix',
    FinanceiroMovimentoPixPagamentoGerarPDF = 'FinanceiroMovimento/PixPagamentoGerarPDF',
    FinanceiroMovimentoPixCobrancaGerarPDF = 'FinanceiroMovimento/PixCobrancaGerarPDF',
    BoletoCompartilhar = 'Boleto/Compartilhar',
    CartaoCompartilhar = 'Cartao/Compartilhar',
    PixCompartilhar = 'Pix/Compartilhar',

    FinanceiroContaRetornoBuscar = 'FinanceiroContaRetorno/Buscar',
    FinanceiroContaRetornoProcessarRetornoBancario = 'FinanceiroContaRetorno/ProcessarRetornoBancario',
    FinanceiroContaLancamentoConsultar = 'FinanceiroContaLancamento/Consultar',
    FinanceiroContaLancamentoValoresTotais = 'FinanceiroContaLancamento/ValoresTotais',
    FinanceiroContaLancamentoRemover = 'FinanceiroContaLancamento/Remover',
    FinanceiroContaLancamentoEstornar = 'FinanceiroContaLancamento/Estornar',
    FinanceiroContaLancamentoInserir = 'FinanceiroContaLancamento/Inserir',
    FinanceiroContaLancamentoAlterar = 'FinanceiroContaLancamento/Alterar',

    NFCeConsultar = 'NFCe/Consultar',
    NFCeAlterar = 'NFCe/Alterar',
    NFCeInserir = 'NFCe/Inserir',
    NFCeRemover = 'NFCe/Remover',
    NFCeValoresTotais = 'nfce/ValoresTotais',
    NFCeEnviar = 'NFCe/Enviar',
    NFCeCancelar = 'NFCe/Cancelar',
    NFCeCompartilhar = 'NFCe/Compartilhar',
    NFCeFinanceiro = 'NFCe/Financeiro',
    NFCeEstoque = 'NFCe/Estoque',

    VendaExternaValoresTotais = 'VendaExterna/ValoresTotais',
    VendaExternaGet = 'VendaExterna/Consultar',
    VendaExternaPost = 'VendaExterna/Inserir',
    VendaExternaPut = 'VendaExterna/Alterar',
    VendaExternaRemove = 'VendaExterna/Remover',
    VendaExternaGerarNotaFiscalRetorno = 'VendaExterna/GerarNotaFiscalRetorno',
    VendaExternaAtualizarStatus = 'VendaExterna/AtualizarStatus',

    RelatorioFinanceiroContaExtrato = 'Relatorio/FinanceiroContaExtrato',

    RomaneioGet = '/Romaneio/Buscar',
    RomaneioValoresTotais = '/Romaneio/ValoresTotais',
    RomaneioPost = '/Romaneio/Inserir',
    RomaneioPut = '/Romaneio/Alterar',
    RomaneioDelete = '/Romaneio/Remover',

    NotaFiscalConsultar = 'NotaFiscal/Consultar',
    NotaFiscalCancelar = 'NotaFiscal/Cancelar',
    NotaFiscal = 'NotaFiscal/NotaFiscal',
    NotaFiscalTotais = 'NotaFiscal/ValoresTotais',
    NotaFiscalPreVisualizar = 'NotaFiscal/PreVisualizar',
    NotaFiscalGerarDanfes = 'NotaFiscal/GerarDANFES',
    NotaFiscalCalcularImpostos = 'NotaFiscal/CalcularImpostos',
    NotaFiscalFinanceiro = 'NotaFiscal/Financeiro',
    NotaFiscalEstoque = 'NotaFiscal/Estoque',
    NotaFiscalCompartilhar = 'NotaFiscal/Compartilhar',
    NotaFiscalEnviarExpedicao = 'NotaFiscal/EnviarExpedicao',
    NotaFiscalStatusServico = 'NotaFiscal/StatusServico',

    NotaFiscalRegraPreenchimentoConsultar = 'NotaFiscalRegraPreenchimento/Consultar',
    NotaFiscalRegraPreenchimentoInserir = 'NotaFiscalRegraPreenchimento/Inserir',
    NotaFiscalRegraPreenchimentoAlterar = 'NotaFiscalRegraPreenchimento/Alterar',
    NotaFiscalRegraPreenchimentoRemover = 'NotaFiscalRegraPreenchimento/Remover',

    OfxConsultar = 'Ofx/Consultar',
    OfxCarregarArquivo = 'Ofx/CarregarArquivo',
    OfxRemover = 'Ofx/Remover',
}
